import {
  AutoGraphOutlined,
  BlurOnOutlined,
  IntegrationInstructionsOutlined,
  ReceiptLongOutlined,
  SettingsSuggestOutlined,
  ThunderstormOutlined,
} from "@mui/icons-material";

// Card copy lives in the i18n resources (projects.cards); the icons are matched
// to the translated entries by position.
export const projectCardIcons = [
  <ThunderstormOutlined color="primary" fontSize="large" />,
  <AutoGraphOutlined color="primary" fontSize="large" />,
  <BlurOnOutlined color="primary" fontSize="large" />,
  <ReceiptLongOutlined color="primary" fontSize="large" />,
  <SettingsSuggestOutlined color="primary" fontSize="large" />,
  <IntegrationInstructionsOutlined color="primary" fontSize="large" />,
];
